import React, { Suspense, lazy, useLayoutEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Route, Routes, useLocation } from "react-router-dom";
import Loading from "./Loading";

// Pages are lazy-loaded so each route ships as its own chunk; the Suspense
// fallback shows the loader while a chunk downloads (mostly hidden by the veil).
const Home = lazy(() => import("../pages/HomePage"));
const Products = lazy(() => import("../pages/ProductsPage"));
const About = lazy(() => import("../pages/AboutPage"));
const SingleProduct = lazy(() => import("../pages/SingleProductPage"));
const Cart = lazy(() => import("../pages/CartPage"));
const Error = lazy(() => import("../pages/ErrorPage"));
const Catering = lazy(() => import("../pages/CateringPage"));
const Info = lazy(() => import("../pages/InfoPage"));
const Extra = lazy(() => import("../pages/ExtraProductsPage"));

const AnimatedRoutes = () => {
  const location = useLocation();

  // jump to top while the veil still covers the screen
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      {/* dark curtain that sweeps up on every route change (and first load) */}
      <motion.div
        key={`veil-${location.pathname}`}
        className="route-veil"
        aria-hidden="true"
        initial={{ scaleY: 1 }}
        animate={{ scaleY: [1, 1, 0] }}
        transition={{
          duration: 0.9,
          times: [0, 0.3, 1],
          ease: ["linear", [0.76, 0, 0.24, 1]],
        }}
        style={{ transformOrigin: "top" }}
      />
      <AnimatePresence mode="wait">
        <Suspense fallback={<Loading />} key={location.pathname}>
          <Routes location={location}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/pronajem-party-stanu-vybaveni" element={<Products />} />
            <Route path="/barovy-catering-na-akce" element={<Catering />} />
            <Route path="/info" element={<Info />} />
            <Route path="/extra" element={<Extra />} />
            <Route path="/products/:id" element={<SingleProduct />} />
            <Route path="*" element={<Error />} />
          </Routes>
        </Suspense>
      </AnimatePresence>
    </>
  );
};

export default AnimatedRoutes;
